import { render, staticRenderFns } from "./SlidePage2.vue?vue&type=template&id=80fbb57e&"
import script from "./SlidePage2.vue?vue&type=script&lang=ts&"
export * from "./SlidePage2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports